export enum AttachmentSources {
  SmartsheetContentLibrary = 'smartsheet-content-library',
  SmartsheetContentLibraryUppy = 'smartsheet-content-library-uppy'
}
